import { ReactNode } from "react";
import { Flex } from "antd";
import type { Icon } from "@phosphor-icons/react";
import { DnaDimensionHeader } from "./DnaDimensionHeader";

export type DnaEditSectionProps = Readonly<{
  icon: Icon;
  question: string;
  title: string;
  children: ReactNode;
}>;

export const DnaEditSection = ({
  icon,
  question,
  title,
  children,
}: DnaEditSectionProps) => (
  <Flex vertical gap={16}>
    <DnaDimensionHeader icon={icon} label={question} title={title} />
    {children}
  </Flex>
);
